module.exports = __webpack_public_path__ + "static/media/map.aa513eef.png";